var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card-view"},[_c('h2',[_vm._v(_vm._s(`${_vm.user.first_name}'s ${_vm.$t('text.cards')}`))]),_c('add-card')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }